module.exports = __webpack_public_path__ + "static/img/yigouyao@3x.a88e8c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/im/yigouyao@3x.png
// module id = tHKo
// module chunks = 1